import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "./Hub.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import hh from "../../images/hub-img.webp";
import cc from "../../images/hub-card.webp";
import gg from "../../images/gift-green.svg";
import axios from "axios";
import ff from "../../images/pp-logo.gif";
import { END_URL, IMG_URL } from "../../config";
import { slugify } from '../../utils/slugify';
import arr from "../../images/downarr.svg"

function Hub() {

    const { slug } = useParams();

    const [hub, setHub] = useState(null);

    const [blog, setblog] = useState([]);

    const [archetype,setarchetype]= useState([]);

    const [faqData,setfaqData]= useState([]);

    const [loading, setLoading] = useState(true);

    const [openIndex, setOpenIndex] = useState(0);

    const [CarrerModal, setCarrerModal] = useState(false);
    const [careerContent, setCareerContent] = useState("");

    useEffect(() => {
        fetchHub();
    }, [slug]);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };


    const fetchHub = async () => {
        try {
            setLoading(true);

            const response = await axios.get(
                `${END_URL}/hub/${slug}`
            );

            setHub(response.data.data);
            setblog(response.data.blogs);
            setarchetype(response.data.quiz_arche_type);
            setfaqData(response.data.quiz_faq);

        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {

        return (

                <div className="loadingDiv" >
                
                    <img src={ff}  alt="Loading..." />
        
                </div>
        );
    }

    const careerCards = [
    {
      image: hub?.career_image_1,
      content: hub?.career_content_1,
      buttonLabel: hub?.career_button_label_1,
      popupcontent: hub?.career_button_link_1,
    },
    {
      image: hub?.career_image_2,
      content: hub?.career_content_2,
      buttonLabel: hub?.career_button_label_2,
      popupcontent: hub?.career_button_link_2,
    },
    {
      image: hub?.career_image_3,
      content: hub?.career_content_3,
      buttonLabel: hub?.career_button_label_3,
      popupcontent: hub?.career_button_link_3,
    },
    {
      image: hub?.career_image_4,
      content: hub?.career_content_4,
      buttonLabel: hub?.career_button_label_4,
      popupcontent: hub?.career_button_link_4,
    },
    {
      image: hub?.career_image_5,
      content: hub?.career_content_5,
      buttonLabel: hub?.career_button_label_5,
      popupcontent: hub?.career_button_link_5,
    },
    {
      image: hub?.career_image_6,
      content: hub?.career_content_6,
      buttonLabel: hub?.career_button_label_6,
      popupcontent: hub?.career_button_link_6,
    },
  ].filter(card => card.content);

  return (
    <>
    <div className="hub-main">
      <div className="ques-main hub-cont-banner">
        <div className="container-fluid">
          <div className="row ques-row">
            <div className="col-12">
              <div className="ques-top" style={{'--banner_image': `url(${IMG_URL}/d0/${hub?.quiz_banner})`}}>
          
                <div className="ques-top-title">
                
                  <div className="quiz-banner-content" dangerouslySetInnerHTML={{__html:hub?.quiz_content}}/>

                  <div className="hub-banner-bnts">

                    {hub?.quiz_explore_link && hub?.quiz_explore_btn && (
                      <a href={`/${hub?.quiz_explore_link}`} class="new-commom-btn homearche-explore">

                        <span>{hub?.quiz_explore_btn}</span>

                        <span class="righ-arr">
                          <FontAwesomeIcon icon={faArrowRight} />
                        </span>
                      </a>
                    )}

                    {hub?.quiz_reveal_link && hub?.quiz_reveal_btn && (

                      <a href={`/${hub?.quiz_reveal_link}`} class="new-commom-btn hub-banner-reveal">

                        <span>{hub?.quiz_reveal_btn}</span>

                        <span class="righ-arr">
                          <FontAwesomeIcon icon={faArrowRight} />
                        </span>
                      </a>

                    )}

                  </div>

                  <div dangerouslySetInnerHTML={{__html:hub?.quiz_reveal_content}}/>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="hub-section">
        <div className="container">
          <div className="row hub-list-row">
            <div className="col-md-6">

              <div className="hub-list-div">

                <div className="hub-reveal" dangerouslySetInnerHTML={{__html:hub?.quiz_pattern_content}} />

                {hub?.quiz_pattern_link && hub?.quiz_pattern_btn && (
                  <a href={`/${hub?.quiz_pattern_link}`} class="new-commom-btn hub-banner-reveal">

                    <span>{hub?.quiz_pattern_btn}</span>

                    <span class="righ-arr">
                      <FontAwesomeIcon icon={faArrowRight} />
                    </span>
                  </a>
                )}

              </div>
            </div>

            <div className="col-md-6">
              <div className="hub-list-image">
                <img src={`${IMG_URL}/d0/${hub?.quiz_reveal_image}`} alt="" />
              </div>
            </div>
          </div>

          <div className="row hub-pattern-card-row">

            <div className="hub-pattern-card-title">

              <span>
                <img src={`${IMG_URL}/d0/${hub?.quiz_career_icon}`} alt="" />
              </span>
              
              <h2>{hub?.quiz_career_title}</h2>

            </div>

            <div className="hub-pattern-card-outer">

                {careerCards.map((card, index) => (
                  <div className="hub-pattern-cards" key={index}>
                    <div>
                      <img
                        src={`${IMG_URL}/d0/${card.image}`}
                        alt=""
                      />
                    </div>

                    <div className="hub-pattern-cards-content">
                      <div
                        className="hub-carrer-content"
                        dangerouslySetInnerHTML={{
                          __html: card.content,
                        }}
                      />

                      {card.popupcontent && card.buttonLabel && (
                        <a
                          onClick={(e) => {
                              e.preventDefault();
                              setCareerContent(card.popupcontent);
                              setCarrerModal(true);
                            }}
                          className="new-commom-btn hub-banner-reveal"
                        >
                          <span>{card.buttonLabel}</span>

                          <span className="righ-arr">
                            <FontAwesomeIcon icon={faArrowRight} />
                          </span>
                        </a>
                      )}
                    </div>
                  </div>
                ))}

            </div>

          </div>

            <div className="row hub-pattern-popular">
            
            <div className="hub-pattern-card-title">
              <span>
                <img src={`${IMG_URL}/d0/${hub?.quiz_archetype_icon}`} alt="" />
              </span>
                
              <div className="aeche-type-title" dangerouslySetInnerHTML={{__html:hub?.quiz_archetype_title}} />

            </div>

           <div className="hub-pattern-card-outer hub-pattern-card-outer-poular">
              {[1, 2, 3, 4].map((num) => (
                <div className="hub-pattern-cards" key={num}>
                  <div>
                    <img
                      src={`${IMG_URL}/d0/${archetype?.[`archetype_image_${num}`]}`}
                      alt=""
                    />
                  </div>

                  <div className="hub-pattern-cards-content">
                    <div
                      dangerouslySetInnerHTML={{
                        __html: archetype?.[`archetype_content_${num}`] || "",
                      }}
                    />

                    {archetype?.[`archetype_button_label_${num}`] && (
                      <a
                        href={`/${archetype?.[`archetype_button_link_${num}`] || ""}`}
                        className="new-commom-btn hub-banner-reveal"
                      >
                        <span>
                          {archetype?.[`archetype_button_label_${num}`]}
                        </span>

                        <span className="righ-arr">
                          <FontAwesomeIcon icon={faArrowRight} />
                        </span>
                      </a>
                    )}
                  </div>
                </div>
              ))}
            </div>

          </div>

          <div className="row hub-pattern-blog">

            <div className="hub-pattern-card-title">
              <span>

                <img src={`${IMG_URL}/d0/${hub.quiz_blog_icon}`} alt="" />
              </span>

              <div dangerouslySetInnerHTML={{__html:hub?.quiz_blog_content}}/>

            </div>

            <div className="hub-pattern-card-outer hub-pattern-card-outer-blog">

                {blog && blog?.length > 0 && (

                  blog.map((item, index) => (
                    <div className="hub-pattern-cards">

                        <div>
                          {" "}
                          <img src={`${IMG_URL}/d0/${item?.image}`} alt="" />

                        </div>

                        <div className="hub-pattern-cards-content">

                          <h5>{item?.topic?.topicname}</h5>

                          <p>{item?.title}</p>

                          <a href={`/blog/detail/${slugify(item.title)}`}class="new-commom-btn hub-banner-reveal">

                            <span>Read Article</span>

                            <span class="righ-arr">
                              <FontAwesomeIcon icon={faArrowRight} />
                            </span>
                          </a>
                        </div>

                    </div>

                   ))
                )}

            </div>
          </div>

           <div className="row hub-faq-question">

              <div className="hub-pattern-card-title faq-title-head">

                <span>

                  <img src={`${IMG_URL}/d0/${hub.quiz_faq_icon}`} alt="" />

                </span>

                  <div dangerouslySetInnerHTML={{__html:hub?.faq_content}} />

              </div>

              <div className="col-12 col-sm-12 col-md-12">

                <div className="faq-container">

                  {faqData.map((item, index) => (
                      <div key={index} className="faq-item" onClick={() => toggle(index)}>
                        <div className="faq-title">
                          <h3>{item.question}</h3>
                          <span className="arrow-icon">
                            <img className={openIndex === index ? "rotate1" : ""} src={arr} alt="" />
                          </span>
                        </div>
                        {openIndex === index && (
                          <div className="faq-content">
                            <p dangerouslySetInnerHTML={{ __html: item?.answer }}></p>
                          </div>
                        )}
                        <hr />
                      </div>

                  ))}
                </div>
              </div>


            </div>

        </div>
      </div>
    </div>

      {CarrerModal && (
        <div className="newdashpop-overlay lock-dashboard carrer-banner">
          <div className="newdashpop-inner">
            <div className="newdashpop-container">
              <button
                className="newdashpop-close"
                onClick={() => {
                  setCarrerModal(false);
                  setCareerContent("");
                }}
              >
                &times;
              </button>

              <div className="conent-pop lock-dashboard-content">
                <div className="dash-loc-title">

                  <div
                    dangerouslySetInnerHTML={{ __html: careerContent }}
                  />

                </div>
              </div>
            </div>
          </div>
        </div>
      )}

    </>
  );
}

export default Hub;
